import React from 'react';
import { useTranslation } from 'react-i18next';
import HighlightedText from '@/components/help/HighlightedText';
import { parseDocContent } from '@/utils/helpDocs';

interface HelpDocContentProps {
  content: string;
  image?: string;
  highlightQuery?: string;
}

/** Renders a doc subsection body (paragraphs, optional table, optional image). */
const HelpDocContent: React.FC<HelpDocContentProps> = ({ content, image, highlightQuery }) => {
  const { t } = useTranslation('help');
  const { mainContent, tableContent } = parseDocContent(content);

  return (
    <>
      {image && (
        <figure className="help-page__doc-image-wrap">
          <img src={image} alt="" className="help-page__doc-image" />
        </figure>
      )}
      <div className="help-page__doc-content">
        {mainContent.split(/\n\n+/).map((paragraph, index) => (
          <p key={index} className="help-page__doc-paragraph" style={{ whiteSpace: 'pre-line' }}>
            <HighlightedText text={paragraph} query={highlightQuery} />
          </p>
        ))}
        {tableContent != null && (
          <div className="help-page__doc-table-wrap" role="region" aria-label={t('docs.referenceTableAria')}>
            <pre className="help-page__doc-table">
              <HighlightedText text={tableContent.trim()} query={highlightQuery} />
            </pre>
          </div>
        )}
      </div>
    </>
  );
};

export default HelpDocContent;
